module.exports = __webpack_public_path__ + "static/media/icono_campana_telefono.fb9516be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/icono_campana_telefono.svg
// module id = 1757
// module chunks = 0